<template>
  <div class="dynamic-tables">
    <h2 class="page-title text-center">Penilaian Pelaksanaan Pusat</h2>
    <Widget customHeader>
      <div class="d-flex justify-content-end mb-3">
        <div class="d-flex align-items-start">
          <div class="d-flex flex-column">
            <div v-for="(filter, index) in filters" :key="index" class="d-flex align-items-center mb-2">
              <label class="mr-2 mb-0 text-nowrap">Filter {{ index + 1 }}</label>

              <select v-model="filter.field" class="form-control mr-2" @change="resetFilter(filter)">
                <option
                  v-for="option in filterFields"
                  :key="option.value"
                  :value="option.value"
                  :disabled="isFieldSelected(option.value, filter.field)"
                >
                  {{ option.label }}
                </option>
              </select>

              <div v-if="isRangeSearch(filter.field)" class="d-flex align-items-center">
                <label class="mb-0 mr-1">Mulai</label>
                <input v-model="filter.from" type="date" class="form-control mr-2" />
                <label class="mb-0 mr-1">Sampai</label>
                <input v-model="filter.to" type="date" class="form-control mr-2" />
              </div>

              <select v-else-if="filter.field === 'prioritas'" v-model="filter.value" class="form-control mr-2">
                <option value="">Pilih Prioritas</option>
                <option value="true">Ya</option>
                <option value="false">Tidak</option>
              </select>

              <select
                v-else-if="filter.field === 'jenis_rencana_aksi'"
                v-model="filter.value"
                class="form-control mr-2"
              >
                <option value="">Pilih Jenis</option>
                <option value="Pertama">Pertama</option>
                <option value="Lanjutan">Lanjutan</option>
              </select>

              <input v-else v-model="filter.value" type="text" class="form-control mr-2" />

              <button v-if="index > 0" type="button" class="btn btn-outline-danger" @click="removeFilter(index)">
                Hapus
              </button>
            </div>

            <button
              v-if="filters.length < 3"
              type="button"
              class="btn btn-outline-primary align-self-start"
              @click="addFilter"
            >
              Tambah Filter
            </button>
          </div>

          <div class="d-flex ml-4">
            <div class="d-flex align-items-center mr-2">
              <label class="mb-0 text-nowrap">Sort By: </label>
            </div>

            <select v-model="sort.field" class="form-control">
              <option value="tanggal_penilaian">Tgl. Penilaian</option>
              <option value="createdAt">Tgl. Dibuat</option>
              <option value="no_kkprl">No. KKPRL</option>
              <option value="nama_pemegang">Nama Pemegang</option>
              <option value="prioritas">Prioritas</option>
            </select>

            <select v-model="sort.direction" class="form-control ml-2">
              <option value="DESC">DESC</option>
              <option value="ASC">ASC</option>
            </select>
          </div>
        </div>
      </div>

      <table class="table" style="width: 100%">
        <thead>
          <tr>
            <th>No</th>
            <th>Jenis</th>
            <th>Prioritas</th>
            <th>No. KKPRL</th>
            <th>Nama Pemegang</th>
            <th>Metode</th>
            <th>Tanggal Penilaian</th>
            <th>Status</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="isLoading">
            <td colspan="9" class="text-center">Memuat data...</td>
          </tr>
          <tr v-else-if="!dataPenilaian.length">
            <td colspan="9" class="text-center">Tidak ada data</td>
          </tr>
          <template v-else>
            <tr v-for="(data, index) in dataPenilaian" :key="data.id">
              <td>{{ pagination.firstInPage + index }}</td>
              <td>{{ data.jenis_rencana_aksi || '-' }}</td>
              <td>
                <span :class="['badge', data.prioritas ? 'bg-success' : 'bg-secondary']">
                  {{ data.prioritas ? 'Ya' : 'Tidak' }}
                </span>
              </td>
              <td>{{ data.no_kkprl || '-' }}</td>
              <td>{{ data.nama_pemegang || '-' }}</td>
              <td>{{ data.metode_penilaian_pelaksanaan || '-' }}</td>
              <td>{{ formatDate(data.tanggal_penilaian, 'DD MMMM YYYY') || '-' }}</td>
              <td>{{ data.status || '-' }}</td>
              <td>
                <div class="d-flex flex-column flex-wrap">
                  <div v-if="canShowAksi('detail', data.status)" class="mb-2">
                    <b-button size="sm" variant="info" @click="bukaForm(data)"> Detail </b-button>
                  </div>
                  <div v-if="canShowAksi('penilaian', data.status)" class="mb-2">
                    <b-button size="sm" variant="primary" @click="bukaForm(data)"> Penilaian Pelaksanaan </b-button>
                  </div>
                  <div v-if="canShowAksi('submit', data.status)">
                    <b-button size="sm" variant="success" @click="submitPenilaian(data)"> Submit Penilaian </b-button>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <div class="d-flex justify-content-between mt-4">
        <div>
          <template v-if="pagination.total">
            Menampilkan {{ pagination.firstInPage }} sampai
            {{
              pagination.currentPage !== pagination.lastPage
                ? pagination.limit * pagination.currentPage
                : pagination.total
            }}
            dari {{ pagination.total }} data
          </template>
        </div>

        <nav aria-label="Page navigation">
          <ul class="pagination">
            <li :class="['page-item', { disabled: pagination.currentPage === 1 }]">
              <a class="page-link" href="#" @click.prevent="changePage({ option: 'first' })">Awal</a>
            </li>
            <li :class="['page-item', { disabled: pagination.currentPage === 1 }]">
              <a class="page-link" href="#" @click.prevent="changePage({ option: 'prev' })">Sebelumnya</a>
            </li>

            <li v-for="(i, index) in pagination.pageNumber" :key="index" class="page-item">
              <a
                :class="['page-link', { active: i === `${pagination.currentPage}` }]"
                href="#"
                @click.prevent="changePage({ page: i })"
              >
                {{ i }}
              </a>
            </li>

            <li :class="['page-item', { disabled: pagination.currentPage === pagination.lastPage }]">
              <a class="page-link" href="#" @click.prevent="changePage({ option: 'next' })">Selanjutnya</a>
            </li>
            <li :class="['page-item', { disabled: pagination.currentPage === pagination.lastPage }]">
              <a class="page-link" href="#" @click.prevent="changePage({ option: 'last' })">Akhir</a>
            </li>
          </ul>
        </nav>
      </div>
    </Widget>
  </div>
</template>

<script>
import api from '@/services/api'
import { formatDate } from '@/helper/helpernew'
import { STATUS_RENCANA_AKSI } from '@/consts/consts'
import Swal from 'sweetalert2'

const AKSI_PENILAIAN = {
  detail: [STATUS_RENCANA_AKSI.SELESAI],
  penilaian: [STATUS_RENCANA_AKSI.SIAP_DINILAI, STATUS_RENCANA_AKSI.DALAM_PENILAIAN],
  submit: [STATUS_RENCANA_AKSI.DALAM_PENILAIAN],
}

export default {
  name: 'PenilaianPelaksanaanPusat',
  data() {
    return {
      user: JSON.parse(localStorage.getItem('userPengendalian') || '{}') || {},
      dataPenilaian: [],
      isLoading: false,
      pagination: {
        currentPage: parseInt(this.$route.query.page) || 1,
        lastPage: 1,
        pageNumber: [],
        limit: 10,
        total: 0,
        firstInPage: 0,
      },
      filterFields: [
        { value: 'nama_pemegang', label: 'Nama Pemegang' },
        { value: 'no_kkprl', label: 'No. KKPRL' },
        { value: 'jenis_rencana_aksi', label: 'Jenis' },
        { value: 'metode_penilaian_pelaksanaan', label: 'Metode' },
        { value: 'status', label: 'Status' },
        { value: 'prioritas', label: 'Prioritas' },
        { value: 'tanggal_penilaian', label: 'Tanggal Penilaian' },
      ],
      filters: [{ field: 'nama_pemegang', value: '', from: '', to: '' }],
      sort: {
        field: 'tanggal_penilaian',
        direction: 'DESC',
      },
      debounceTerm: null,
    }
  },
  mounted() {
    this.loadData()
  },
  beforeDestroy() {
    clearTimeout(this.debounceTerm)
  },
  methods: {
    formatDate,

    isRangeSearch(field) {
      return ['tanggal_penilaian'].includes(field)
    },

    isFieldSelected(field, currentField) {
      return field !== currentField && this.filters.some((filter) => filter.field === field)
    },

    resetFilter(filter) {
      filter.value = ''
      filter.from = ''
      filter.to = ''
    },

    addFilter() {
      const field = this.filterFields.find((option) => !this.filters.some((filter) => filter.field === option.value))

      if (field && this.filters.length < 3) {
        this.filters.push({ field: field.value, value: '', from: '', to: '' })
      }
    },

    removeFilter(index) {
      this.filters.splice(index, 1)
    },

    getSearchFilter() {
      return this.filters
        .reduce((conditions, filter) => {
          if (this.isRangeSearch(filter.field)) {
            conditions.push(
              ...[
                filter.from !== '' && `${filter.field},>=,${filter.from}`,
                filter.to !== '' && `${filter.field},<=,${filter.to}`,
              ].filter(Boolean),
            )
            return conditions
          }

          if (filter.value !== '' && filter.value !== null) {
            const operator = filter.field === 'prioritas' ? '=' : 'like'
            conditions.push(`${filter.field},${operator},${filter.value}`)
          }

          return conditions
        }, [])
        .join(';')
    },

    buildFilter() {
      const filters = [
        `id_tim_penilai,contains,${this.user.id}`,
        `status,!=,${STATUS_RENCANA_AKSI.DRAFT}`,
        `status,!=,${STATUS_RENCANA_AKSI.PEMENUHAN_KELENGKAPAN_DOKUMEN}`,
        `status,!=,${STATUS_RENCANA_AKSI.MENUNGGU_DATA_PEMRAKARSA}`,
      ]

      const searchFilter = this.getSearchFilter()

      if (searchFilter) {
        filters.push(searchFilter)
      }

      return filters.join(';')
    },

    async loadData() {
      this.isLoading = true

      const url =
        `api/rencana_aksi?page=${this.pagination.currentPage}` +
        `&filter=${this.buildFilter()}` +
        `&sort=${this.sort.field},${this.sort.direction};createdAt,DESC`

      try {
        const response = await api.get(url)
        const result = response.data
        const limit = result.limit || 10
        const total = result.total != null ? result.total : result.data_count || 0

        this.pagination.limit = limit
        this.pagination.total = total
        this.pagination.firstInPage = total ? (this.pagination.currentPage - 1) * limit + 1 : 0
        this.pagination.lastPage = Math.max(1, Math.ceil(total / limit))

        this.setPagination()
        this.dataPenilaian = result.data || []
      } catch (error) {
        this.dataPenilaian = []
        const message = error.response?.data?.message || 'Gagal memuat data Penilaian Pelaksanaan'
        Swal.fire('Gagal', message, 'error')
      } finally {
        this.isLoading = false
      }
    },

    setPagination() {
      this.$router
        .replace({
          path: this.$route.path,
          query: { page: this.pagination.currentPage },
        })
        .catch(() => {})

      this.pagination.pageNumber = []

      if (this.pagination.lastPage > 7) {
        if (this.pagination.currentPage <= 4) {
          this.pagination.pageNumber.push('1', '2', '3', '4', '5')
        } else if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push(
            '1',
            '...',
            `${this.pagination.lastPage - 4}`,
            `${this.pagination.lastPage - 3}`,
            `${this.pagination.lastPage - 2}`,
          )
        } else {
          this.pagination.pageNumber.push(
            '1',
            '...',
            `${this.pagination.currentPage - 1}`,
            `${this.pagination.currentPage}`,
            `${this.pagination.currentPage + 1}`,
          )
        }

        if (this.pagination.currentPage >= this.pagination.lastPage - 2) {
          this.pagination.pageNumber.push(`${this.pagination.lastPage - 1}`, `${this.pagination.lastPage}`)
        } else {
          this.pagination.pageNumber.push('...', `${this.pagination.lastPage}`)
        }
      } else {
        for (let i = 1; i <= this.pagination.lastPage; i++) {
          this.pagination.pageNumber.push(`${i}`)
        }
      }
    },

    async changePage(config = { option: 'next', page: null }) {
      if (config.option === 'next' && this.pagination.currentPage < this.pagination.lastPage) {
        this.pagination.currentPage++
      }
      if (config.option === 'prev' && this.pagination.currentPage > 1) {
        this.pagination.currentPage--
      }
      if (config.option === 'first') {
        this.pagination.currentPage = 1
      }
      if (config.option === 'last') {
        this.pagination.currentPage = this.pagination.lastPage
      }
      if (config.page) {
        this.pagination.currentPage = parseInt(config.page)
      }

      await this.loadData()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    canShowAksi(aksi, status) {
      return (AKSI_PENILAIAN[aksi] || []).includes(status)
    },

    bukaForm(data) {
      this.$router.push({ name: 'FormPenilaianPelaksanaanPusat', params: { id: data.id } })
    },

    async submitPenilaian(data) {
      const result = await Swal.fire({
        icon: 'question',
        title: 'Submit Penilaian?',
        text: 'Apakah Anda yakin ingin submit penilaian pelaksanaan ini?',
        showCancelButton: true,
        confirmButtonText: 'Ya, Submit',
        cancelButtonText: 'Batal',
      })
      if (!result.isConfirmed) return

      // TODO: integrasi submit penilaian menyusul
      console.log('Submit penilaian (dummy):', data.id)
    },
  },
  watch: {
    filters: {
      handler() {
        if (this.debounceTerm) {
          clearTimeout(this.debounceTerm)
        }
        this.debounceTerm = setTimeout(() => {
          this.pagination.currentPage = 1
          this.loadData()
        }, 1000)
      },
      deep: true,
    },

    sort: {
      handler() {
        this.pagination.currentPage = 1
        this.loadData()
      },
      deep: true,
    },
  },
}
</script>
